import Admission from './admission'
import Appointment from './appointment'
import Area from './area'
import Auth from './auth'
import CalendarGoogle from './calendar_google'
import CalendarMicrosoft from './calendar_microsoft'
import Company from './company'
import Department from './department'
import Doctor from './doctor'
import Hospital from './hospital'
import Message from './message'
import Notification from './notification'
import OAuthGoogle from './o_auth_google'
import OAuthMicrosoft from './o_auth_microsoft'
import Order from './order'
import Payment from './payment'
import Pharmaceutical from './pharmaceutical'
import Room from './room'
import Schedule from './schedule'
import Talk from './talk'
import { APIClient } from '@/infrastructure/network/Monitaro/APIClient'

export default class MonitaroGateway {
  apiClient: APIClient
  Admission: Admission
  Appointment: Appointment
  Area: Area
  Auth: Auth
  CalendarGoogle: CalendarGoogle
  CalendarMicrosoft: CalendarMicrosoft
  Company: Company
  Department: Department
  Doctor: Doctor
  Hospital: Hospital
  Message: Message
  Notification: Notification
  OAuthGoogle: OAuthGoogle
  OAuthMicrosoft: OAuthMicrosoft
  Order: Order
  Payment: Payment
  Pharmaceutical: Pharmaceutical
  Room: Room
  Schedule: Schedule
  Talk: Talk

  constructor(apiClient: APIClient) {
    this.apiClient = apiClient
    this.Admission = new Admission(apiClient)
    this.Appointment = new Appointment(apiClient)
    this.Area = new Area(apiClient)
    this.Auth = new Auth(apiClient)
    this.CalendarGoogle = new CalendarGoogle(apiClient)
    this.CalendarMicrosoft = new CalendarMicrosoft(apiClient)
    this.Company = new Company(apiClient)
    this.Department = new Department(apiClient)
    this.Doctor = new Doctor(apiClient)
    this.Hospital = new Hospital(apiClient)
    this.Message = new Message(apiClient)
    this.Notification = new Notification(apiClient)
    this.OAuthGoogle = new OAuthGoogle(apiClient)
    this.OAuthMicrosoft = new OAuthMicrosoft(apiClient)
    this.Order = new Order(apiClient)
    this.Payment = new Payment(apiClient)
    this.Pharmaceutical = new Pharmaceutical(apiClient)
    this.Room = new Room(apiClient)
    this.Schedule = new Schedule(apiClient)
    this.Talk = new Talk(apiClient)
  }
}
